export { EloCaretLeftIcon } from './caret-left-icon'
